import { Component } from 'react'
import { Button, Col, Form, Input, Row } from 'antd'
import Utils from '../../Util/Utils'
import DefaultPropsInterface from '../../Interface/DefaultPropsInterface'
import { PaymentReasonCriteria } from '../../QueryCriteria/PaymentReasonCriteria'

interface Props extends DefaultPropsInterface {
    handleCollapseFilter: () => void
}

interface State {
    form: PaymentReasonCriteria
}

class FilterForm extends Component<Props, State> {
    state = {
        form: {
            ...Utils.getQueryFromLocation(this.props.location),
        },
    }

    componentDidUpdate(prevProps: any) {
        if (
            JSON.stringify(this.props.location.search) !== JSON.stringify(prevProps.location.search) ||
            JSON.stringify(this.props.match.params) !== JSON.stringify(prevProps.match.params)
        ) {
            this.setState({ form: Utils.getQueryFromLocation(this.props.location) })
        }
    }

    handleChangeInput = (field: string, e: any) => {
        const form: any = this.state.form
        form[field] = e.target.value
        this.setState({ form })
    }

    handleFilter = () => {
        let newFilter = {
            ...this.state.form,
            offset: 0,
            limit: 25,
        }
        Utils.pushCleanQueryToHistory(this.props.history, this.props.location, newFilter)
    }

    clearFilter = () => {
        this.setState({ form: {} })
        Utils.pushCleanQueryToHistory(this.props.history, this.props.location, {})
    }

    render() {
        const form: PaymentReasonCriteria = this.state.form

        const disbaleSubmit: boolean = Utils.checkDisableSubmit(form)

        return (
            <Form
                layout={'horizontal'}
                labelAlign={'left'}>
                <Row gutter={24}>
                    <Col
                        xs={24}
                        md={12}
                        lg={8}>
                        <Form.Item label={'Mã'}>
                            <Input
                                autoFocus
                                placeholder={'Tìm kiếm theo mã'}
                                value={form.code}
                                onChange={this.handleChangeInput.bind(this, 'code')}
                                onPressEnter={() => this.handleFilter()}
                            />
                        </Form.Item>
                    </Col>
                    <Col
                        xs={24}
                        md={12}
                        lg={8}>
                        <Form.Item label={'Tên'}>
                            <Input
                                placeholder={'Tìm kiếm theo tên'}
                                value={form.name}
                                onChange={this.handleChangeInput.bind(this, 'name')}
                                onPressEnter={() => this.handleFilter()}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <div className="flex space-between items-center">
                    <span
                        onClick={this.props.handleCollapseFilter}
                        className={'font-size-12 cursor-pointer'}>
                        <i className="fa-solid fa-chevron-up mg-r-3" /> Thu gọn
                    </span>

                    <div>
                        {!disbaleSubmit && (
                            <Button
                                type={'text'}
                                onClick={this.clearFilter}
                                className="font-size-12px">
                                <i className="fa-regular fa-repeat mg-r-5" />
                                Làm mới bộ lọc
                            </Button>
                        )}

                        <Button
                            type={'primary'}
                            onClick={this.handleFilter}
                            disabled={disbaleSubmit}>
                            Tìm kiếm
                        </Button>
                    </div>
                </div>
            </Form>
        )
    }
}

export default FilterForm
